'use strict';

var helper = require('../helper');

module.exports = {

    pushAddToWishlistInteraction (sku, form) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '24',
            'eventname': 'add_to_wishlist',
            'product_id': sku,
            'position': form
        };

        helper.log('Pushing add to wishlist impression from ' + form + ' for sku \'' + sku + '\'!', true);
        helper.push(pushObject);
    },

    pushRemoveFromWishlistInteraction (sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '25',
            'eventname': 'remove_from_wishlist',
            'product_id': sku
        };

        helper.log('Pushing remove from wishlist impression for \'' + sku + '\'!', true);
        helper.push(pushObject);
    }

};
